import { Icon, Popover } from '@gimlite/ui-v1';
import { useMemo } from 'react';
import { EventEntity } from '../../../client/graphql';
import { ComponentInfosSelector } from '../../../common/mapper/eventsInfos.mapper';
import { TimelineGroup } from '../../../components/timeline/timeline.component';
import './session.infos.scss';

export declare namespace SessionInfosType {
  type Props = {
    className?: string;
    data: SessionInfosType.Data;
  };

  type Data = {
    sessionId: string;
    events: EventEntity[];
  };
}

export const SessionInfos = ({
  data: { sessionId, events },
  className = '',
}: SessionInfosType.Props) => {
  const eventListFormated = useMemo(
    () =>
      events.filter(
        ({ state }) => state !== 'CREATED' || state.includes('PENDING'),
      ),
    [events],
  );
  return (
    <div className={`session-infos ${className}`}>
      {sessionId && (
        <Popover
          data={
            <TimelineGroup config={{ height: 'medium', width: 'full' }}>
              {eventListFormated.map((event) => ComponentInfosSelector(event))}
            </TimelineGroup>
          }
          config={{ placement: 'bottomRight', trigger: 'hover' }}
        >
          <div
            onClick={(e) => {
              e.stopPropagation();
            }}
            className="session-infos__pointer"
          >
            <Icon
              config={{
                type: 'faEyeSolid',
                color: 'label',
                size: 'small',
              }}
            ></Icon>
          </div>
        </Popover>
      )}
    </div>
  );
};
